/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditLog,
  AuditLogListParams,
  PaginatedAuditLogList
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type auditLogListResponse200 = {
  data: PaginatedAuditLogList
  status: 200
}
    
export type auditLogListResponseSuccess = (auditLogListResponse200) & {
  headers: Headers;
};
;

export type auditLogListResponse = (auditLogListResponseSuccess)

export const getAuditLogListUrl = (params?: AuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/audit-log/?${stringifiedParams}` : `/api/v1/audit-log/`
}

export const auditLogList = async (params?: AuditLogListParams, options?: RequestInit): Promise<auditLogListResponse> => {
  
  return apiFetch<auditLogListResponse>(getAuditLogListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAuditLogListQueryKey = (params?: AuditLogListParams,) => {
    return [
    `/api/v1/audit-log/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAuditLogListQueryOptions = <TData = Awaited<ReturnType<typeof auditLogList>>, TError = unknown>(params?: AuditLogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditLogListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditLogList>>> = ({ signal }) => auditLogList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditLogList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditLogListQueryResult = NonNullable<Awaited<ReturnType<typeof auditLogList>>>
export type AuditLogListQueryError = unknown


export function useAuditLogList<TData = Awaited<ReturnType<typeof auditLogList>>, TError = unknown>(
 params: undefined |  AuditLogListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditLogList>>,
          TError,
          Awaited<ReturnType<typeof auditLogList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditLogList<TData = Awaited<ReturnType<typeof auditLogList>>, TError = unknown>(
 params?: AuditLogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditLogList>>,
          TError,
          Awaited<ReturnType<typeof auditLogList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditLogList<TData = Awaited<ReturnType<typeof auditLogList>>, TError = unknown>(
 params?: AuditLogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuditLogList<TData = Awaited<ReturnType<typeof auditLogList>>, TError = unknown>(
 params?: AuditLogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditLogListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type auditLogRetrieveResponse200 = {
  data: AuditLog
  status: 200
}
    
export type auditLogRetrieveResponseSuccess = (auditLogRetrieveResponse200) & {
  headers: Headers;
};
;

export type auditLogRetrieveResponse = (auditLogRetrieveResponseSuccess)

export const getAuditLogRetrieveUrl = (id: string,) => {


  

  return `/api/v1/audit-log/${id}/`
}

export const auditLogRetrieve = async (id: string, options?: RequestInit): Promise<auditLogRetrieveResponse> => {
  
  return apiFetch<auditLogRetrieveResponse>(getAuditLogRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAuditLogRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/audit-log/${id}/`
    ] as const;
    }

    
export const getAuditLogRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof auditLogRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditLogRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditLogRetrieve>>> = ({ signal }) => auditLogRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditLogRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditLogRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof auditLogRetrieve>>>
export type AuditLogRetrieveQueryError = unknown


export function useAuditLogRetrieve<TData = Awaited<ReturnType<typeof auditLogRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditLogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof auditLogRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditLogRetrieve<TData = Awaited<ReturnType<typeof auditLogRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditLogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof auditLogRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditLogRetrieve<TData = Awaited<ReturnType<typeof auditLogRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuditLogRetrieve<TData = Awaited<ReturnType<typeof auditLogRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditLogRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




